import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';

import { InsulationBootstrapModule } from './lib/insulation.bootstrap.module';

const loadChildren = () =>
  import('./lib/insulation.lazy.module').then(
    (module) => module.InsulationLazyModule
  );

const defineImport = (path: string) => ({
  path,
  loadChildren,
});

const insulationLazyImports: ComponentNameAndModule[] = [
  defineImport('InsulationWizard'),
  defineImport('InsulationProductOverview'),
  defineImport('InsulationReceipt'),
  defineImport('InsulationWizard'),
  defineImport('InsulationOrderForm'),
];

export { insulationLazyImports, InsulationBootstrapModule };
